import { create } from 'zustand';

export type WsStatus = 'idle' | 'connecting' | 'open' | 'closed';

interface WsState {
  status: WsStatus;
  lastRttMs: number | null;
  lastPongAt: number | null;
  serverClockOffsetMs: number | null;
  setStatus: (status: WsStatus) => void;
  recordPong: (rttMs: number, offsetMs: number) => void;
  reset: () => void;
}

export const useWsStore = create<WsState>((set) => ({
  status: 'idle',
  lastRttMs: null,
  lastPongAt: null,
  serverClockOffsetMs: null,
  setStatus: (status) => set({ status }),
  recordPong: (rttMs, offsetMs) =>
    set({
      lastRttMs: rttMs,
      lastPongAt: Date.now(),
      serverClockOffsetMs: offsetMs,
    }),
  reset: () =>
    set({
      status: 'idle',
      lastRttMs: null,
      lastPongAt: null,
      serverClockOffsetMs: null,
    }),
}));
